<template>
  <div class="reply-item flex">
    <div class="reply-wrapper flex">
      <div class="reply-info">
        <div class="reply-top">
          <a href="javascript:;" @click="navigateReplyUserCenter">
            <span class="user-name">{{ reply.replyUserInfoExtend || reply.replyUserInfo.name}}</span>
          </a>
          回复
          <a href="javascript:;" @click="navigateReplyToUserCenter">
            <span class="user-name">{{ reply.replyToUserInfoExtend || reply.replyToUserInfo.name}}</span>
          </a>
          <span :class="replyClassName">：{{ initReplyContent }}</span>
        </div>
        <div class="reply-bottom flex">
          <span class="create-time">{{ date}}</span>
          <p class="handle-wrapper" v-if="operationBtn">
            <span class="handle-action" ref="handleBtn" @click="handleAction">{{ operationText }}</span>
          </p>
        </div>
        <div class="reply-area" v-show="displayInput" v-if="notMine">
          <div class="input-wrapper">
            <el-input
              type="textarea"
              resize="none"
              maxlength="100"
              show-word-limit
              :autosize="{minRows: 2}"
              :placeholder="inputHolder"
              v-model="replyContent"
            ></el-input>
          </div>
          <div class="reply-wrapper flex">
            <span></span>
            <el-button class="send-reply" :disabled="forbidReply" @click="submitReply">发送</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getFullDate } from "../../utils/date";
import { tranNumber } from "../../utils/feed";
import { apiMap } from "../../utils/apiMap";
let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
export default {
  name: "reply-item",
  props: {
    reply: Object,
    showStatus: Number,
    deleteStatus: Number,
    showScene: String,
  },
  data() {
    return {
      shape: "terse",
      replyContent: "",
      forbidReply: true,
      notMine: true,
      displayInput: false,
      replyClassName: "reply-text",
      operationBtn: true,
    };
  },
  mounted() {
    if (this.reply.userId == this.user.userId) {
      this.notMine = false;
    }
  },
  computed: {
    ...mapGetters(["user"]),
    date() {
      return getFullDate(new Date(this.reply.created_at * 1000));
    },
    inputHolder() {
      return `回复${
        this.reply.replyUserInfoExtend || this.reply.replyUserInfo.name
      }`;
    },
    operationText() {
      if (this.reply.userId !== this.user.userId) {
        this.notMine = true;
        return "回复";
      } else {
        this.notMine = false;
        return "删除";
      }
    },
    initReplyContent() {
      if (this.deleteStatus == 1) {
        this.operationBtn = false;
        this.replyClassName = "withdrawn-text";
        return `[该回复已删除]`;
      } else if (this.showStatus == 0) {
        this.operationBtn = false;
        this.replyClassName = "withdrawn-text";
        return `[该回复已被系统屏蔽]`;
      } else {
        this.replyClassName = "reply-text";
        return this.reply.content;
      }
    },
  },
  methods: {
    handleAction(e) {
      if (this.notMine == true) {
        if (e.target.innerText == "回复") {
          e.target.innerText = "取消";
          this.displayInput = true;
        } else {
          e.target.innerText = "回复";
          this.displayInput = false;
        }
      } else {
        this.$confirm("确定删除该回复吗？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info",
          closeOnClickModal: false,
        })
          .then(() => {
            this.deleteReply((res) => {
              if (res == 1) {
                switch (this.showScene) {
                  case "commentList":
                    this.$emit("handleDelete", this.reply.id);
                    break;
                  case "allReplyList":
                    this.$emit("handleRemove", this.reply.id);
                    break;
                }
              } else {
                this.$message({
                  message: "删除失败，稍后再试",
                  type: "warning",
                  duration: 1500,
                  offset: 230,
                });
              }
            });
          })
          .catch(() => {});
      }
    },
    deleteReply(cb) {
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["removeComment"]["method"],
        url: apiMap["removeComment"]["url"],
        data: `token=${loginUser.token}&commentId=${this.reply.id}&type=2`,
      })
        .then(function (response) {
          cb(response.data.result.statusCode);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    submitReply() {
      let $this = this;
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["replyComment"]["method"],
          url: apiMap["replyComment"]["url"],
          data: `token=${loginUser.token}&commentId=${this.reply.commentId}&commentUserId=${this.reply.userId}&content=${this.replyContent}`,
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            var myReply = {
              commentId: response.data.result.data.commentId,
              commentUserId: $this.reply.userId,
              content: $this.replyContent,
              created_at: Math.round(new Date() / 1000),
              id: $this.reply.id,
              isDeleted: 0,
              isShow: 1,
              praiseStatus: 0,
              replyToUserInfo: $this.reply.replyUserInfo,
              replyToUserInfoExtend: $this.reply.replyUserInfoExtend,
              replyUserInfo: {
                headImgUrl: loginUser.headImgUrl,
                name: loginUser.nickName,
                realName: null,
                thumbHeadImg: loginUser.thumbHeadImg,
              },
              replyUserInfoExtend: loginUser.nickName,
              updated_at: null,
              userId: loginUser.userId,
            };
            switch ($this.showScene) {
              case "commentList":
                $this.$emit("handleReply", myReply);
                break;
              case "allReplyList":
                $this.$emit("updateReplyList", $this.reply.id, myReply);
                break;
            }
            $this.replyContent = "";
            $this.$refs.handleBtn.click();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    navigateReplyUserCenter() {
      if (this.reply.replyUserInfo.userId) {
        this.$router.push({
          path: "/feed",
          query: {
            id: this.reply.replyUserInfo.userId,
          },
        });
      }
    },
    navigateReplyToUserCenter() {
      if (this.reply.replyToUserInfo.userId) {
        this.$router.push({
          path: "/feed",
          query: {
            id: this.reply.replyToUserInfo.userId,
          },
        });
      }
    },
  },
  watch: {
    replyContent(text) {
      if (text === "" || text.trim().length === 0) {
        this.forbidReply = true;
      } else {
        this.forbidReply = false;
      }
    },
  },
};
</script>
<style scoped>
.reply-item {
  padding: 4px 0;
}

.reply-top {
  line-height: 22px;
}

.reply-top a {
  color: #1a70db;
}

.reply-bottom {
  width: 558px;
  line-height: 20px;
}

.reply-bottom .create-time {
  color: #999;
}

.handle-wrapper {
  line-height: 20px;
}

.handle-action {
  display: none;
  margin-left: 15px;
  cursor: pointer;
  color: #1a70db;
}

.reply-item:hover .handle-action {
  display: inline-block;
}

.handle-icon {
  position: relative;
  top: 3px;
  display: inline-block;
  width: 19px;
  height: 17px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: contain;
}

.handle-count {
  margin-left: 5px;
  color: #e74f52;
}

.unpraise {
  background-image: url("../../assets/icon/cl_feed_praise.png");
}

.praised {
  background-image: url("../../assets/icon/cl_feed_praised.png");
}

.input-wrapper {
  margin: 4px 0;
}

.input-wrapper .el-textarea__inner {
  min-height: 50px;
}

.reply-wrapper {
  width: 100%;
  justify-content: space-between;
}

.reply-info {
  width: 100%;
}

.send-reply {
  padding: 4px 10px;
}

.withdrawn-text {
  color: #999;
}
</style>